import { useAppDispatch, useAppSelector } from "app/hooks";
import Button from "shared/components/Button";
import Panel from "shared/components/Panel";
import { setOpenPanel } from "features/settings/details-slice";
import { ReactComponent as TickSVG } from "assets/icons/tick-soft.svg";
import { useCallback } from "react";

interface PanelFieldSelectorProps {}
const PanelFieldSelector: React.FC<PanelFieldSelectorProps> = () => {
  const showPanel = useAppSelector(
    (state) => state.settings.openPanel === "fieldSelector"
  );
  const currentFieldId = useAppSelector(
    (state) => state.panorama.currentFieldDetails?.fid
  );
  const fields = useAppSelector((state) => state.panorama.farmDetails?.fields);
  const dispatch = useAppDispatch();
  const closePanel = useCallback(
    () => dispatch(setOpenPanel(null)),
    [dispatch]
  );
  return (
    <Panel
      showPanel={showPanel}
      direction="left"
      retainBottomMenu
      headerBorder="BorderBottom"
      closePanel={closePanel}
      underlayClass="NoUnderlay"
      headerElement={<h2>Select Field</h2>}
    >
      <div className="DisplayFlex FlexColumn">
        {fields && fields.length > 0 ? (
          <ul className="DisplayFlex FlexColumn FieldSelectorList">
            {fields.map((field, index) => {
              const isCurrentField = currentFieldId === field.fid;
              return (
                <Button
                  key={`FIELD_OPTION_${field.fid}_${index}`}
                  colour="WhiteAlt"
                  additionalClassNames={`ListItemButton NoBorder ${
                    isCurrentField ? "Selected" : ""
                  }`}
                  onClick={() => {
                    window.krpano.call(
                      `skin_loadscene(${field.name}, get(scene_load.blend), 0, false)`
                    );
                    closePanel();
                  }}
                  icon={
                    isCurrentField && (
                      <TickSVG
                        height={16}
                        width={16}
                        className="BtnIcon BtnIconRight SVGFillTheme"
                      />
                    )
                  }
                  children={field.title}
                />
              );
            })}
          </ul>
        ) : (
          <h2>No farm details available</h2>
        )}
      </div>
    </Panel>
  );
};

export default PanelFieldSelector;
